module.exports = __webpack_public_path__ + "fonts/text-regular.f540ea56.woff";